import { UserContextQuery } from '../../context/user/operation.generated';
import { DriveAccessRoleEnum, WorkspaceMember, WorkspaceType } from './types';

export const getWorkspaceTypeByName = (name: string) => {
  switch (name.toLowerCase()) {
    case WorkspaceType.Personal.toLowerCase():
      return WorkspaceType.Personal;
    case WorkspaceType.Team.toLowerCase():
      return WorkspaceType.Team;

    // Shared workspaces never named Shared - alwyas will be Personal. This doesn't work.
    case WorkspaceType.Shared.toLowerCase():
      return WorkspaceType.Shared;

    case WorkspaceType.New.toLowerCase():
      return WorkspaceType.New;

    case WorkspaceType.Custom.toLowerCase():
    default:
      return WorkspaceType.Custom;
  }
};

export const mapAccessToRole = (access: string) => {
  switch (access) {
    case 'Full access':
      return DriveAccessRoleEnum.FullAccess;
    case 'Can view':
      return DriveAccessRoleEnum.ReadOnly;
    default:
      break;
  }
};
export const mapRoleToAccess = (role?: DriveAccessRoleEnum) => {
  switch (role) {
    case DriveAccessRoleEnum.FullAccess:
      return 'Full access';
    case DriveAccessRoleEnum.ReadOnly:
      return 'Can view';
    default:
      return '';
  }
};

type TeamMember = NonNullable<UserContextQuery['user']['team']>['members'][0];

export const mapTeamMemberToWorkspaceMember = ({
  userId,
  teamMemberId,
  teamMember,
  driveRole,
  checked = false,
}: {
  userId: string;
  teamMemberId: string;
  teamMember: TeamMember;
  driveRole?: DriveAccessRoleEnum;
  checked?: boolean;
}): WorkspaceMember => {
  let access = mapRoleToAccess(driveRole);
  /**
   * @TODO follow up, remove hard code
   */
  if (teamMember.role === 'collaborator') {
    access = 'Comment only';
  }
  return {
    id: teamMember.id,
    name: teamMember.name,
    initials: teamMember.initials,
    email: teamMember.email,
    access,
    isSelf: userId === teamMemberId,
    teamRole: teamMember.role,
    checked,
  };
};

/**
 * @TODO follow up, remove hard code
 * Returns true if contains collaborators and the access is set to
 * a value that is not view only
 */
export const assertWorkspaceAccessWarning = (
  workspaceMembers: WorkspaceMember[],
  memberIds: string[],
  driveRole: string
) => {
  const role = mapAccessToRole(driveRole);
  const hasCollaborators = Boolean(
    memberIds.find(memberId => {
      const workspaceMember = workspaceMembers.find(
        member => member.id === memberId
      );
      return workspaceMember && workspaceMember.teamRole === 'collaborator';
    })
  );

  return hasCollaborators && role !== DriveAccessRoleEnum.ReadOnly;
};

export default {
  getWorkspaceTypeByName,
  mapAccessToRole,
  mapRoleToAccess,
  mapTeamMemberToWorkspaceMember,
  assertWorkspaceAccessWarning,
};
